<template>
  <div class="container">
    <div class="list-container f-column-b">
      <div class="list-header">
        <h3 class="title">近期开标</h3>
      </div>
      <div class="info-list f-column-b">
        <ul v-if="list.length">
          <li v-for="(item, index) in list" :key="index" class="info-item" @click="rowClick(item)">
            <span class="point" />
            <span class="flex-1 text-cut ml-20 title-txt">{{ item.gonggaoTitle }}</span>
            <span class="ml-40 color-999">{{ item.openingTime | parseTime('{y}-{m}-{d}') }}</span>
          </li>
        </ul>
        <no-data v-else />
      </div>
    </div>
    <info-pagination
      :total="total"
      :current-page.sync="curPage"
      :page-size="pageSize"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { PROJECT_STATUS_OPTIONS } from "@/utils/constant";
import NoData from "@/components/NoData.vue";
import InfoPagination from "@/components/InfoPagination.vue";
import purchaseApi from "@/api/purchase";

export default {
  name: "RecentBidding",
  components: { InfoPagination, NoData },
  props: {
    cateInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      title: "",
      curPage: 1,
      pageSize: 15,
      total: 0,
      list: []
    };
  },
  // 监听属性 类似于data概念
  computed: {
    ...mapGetters(["activeMenuId"]),
    isSearch() {
      return this.$route.query && Object.prototype.hasOwnProperty.call(this.$route.query, "title")
    }
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.title = this.$route.query.title || ""
    this.getList()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
  },
  // 方法集合
  methods: {
    // 获取列表
    getList() {
      purchaseApi.pageForOpenTender({
        pageNo: this.curPage,
        pageSize: this.pageSize
      }).then(res => {
        if (res.code === 0) {
          const data = res.data || {}
          const list = data.list || []
          this.total = data.total || 0
          const statusList = Object.values(PROJECT_STATUS_OPTIONS)
          list.forEach(e => {
            e.status_name = statusList.find(f => f.code === e.status).label
          })
          this.list = data.list || []
        }
      })
    },
    // 翻页
    handleCurrentChange(val) {
      this.curPage = val
      this.getList()
    },
    // 行点击
    rowClick(row) {
      this.$router.push({
        name: "projectDetail",
        query: {
          id: row.id
        }
      })
    }
  }
};
</script>

<style scoped lang="scss">
.list-container{
	border: 1px solid #ddd;
	padding: 0 20px;
	min-height: 800px;
	.list-header{
		height: 60px;
		line-height: 60px;
		border-bottom: 2px solid #ddd;
		.title{
			font-size: 24px;
			color: $--color-primary;
			position: relative;
			&::after{
				content: '';
				width: 96px;
				height: 2px;
				background-color: $--color-primary;
				position: absolute;
				bottom: 0;
				left: 0;
			}
		}
	}
	.info-list{
		flex: 1;
		min-height: 0;
		padding-bottom: 10px;
		.info-item{
			height: 50px;
			display: flex;
			align-items: center;
			cursor: pointer;
			border-bottom: 1px solid #ddd;
			&:hover{
				.title-txt{
					color: $--color-primary;
				}
			}
			&:last-child{
				border: none;
			}
			.point{
				width: 5px;
				height: 5px;
				background-color: $--color-primary;
			}
		}
	}
}
</style>
